import LoaderMain from 'components/shared/LoaderMain';
import { faPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const FlightResultListSkeleton: FC = () => {
    return (
      <div className="flight-results">
        <div className="flight-filter-wr default-shadow">
          <CheckboxSection />
          <SliderSection />
          <SliderSection />
          <SliderSection />
          <SliderSection />
          <SliderSection />
          <CheckboxSection />
          <CheckboxSection />
          <CheckboxSection />
        </div>
        <div className="flight-list">
          <div>
            {[...Array(5)].map((_, index) => (
              <div className="ticket default-shadow" key={index}>
                <div className="ticket-routes">
                  {[...Array(2)].map((_, index) => (
                    <div className="ticket-route" key={index}>
                      <span className="ticket-airline">
                        <Skeleton height={30} />
                      </span>
                      <div className="ticket-data">
                        <div className="ticket-time">
                          <div className="ticket-time-inner">
                            <span className="date">
                              <Skeleton width={85} />
                            </span>
                            <span>
                              {' '}
                              <Skeleton width={90} />
                            </span>
                            <span className="city">
                              {' '}
                              <Skeleton width={70} />
                            </span>
                          </div>
                        </div>
                        <div className="ticket-directions">
                          <span className="stops-duration">
                            <Skeleton width={70} />
                          </span>
                          <span className="line">
                            <FontAwesomeIcon icon={faPlane as any} />
                            <span>
                              <Skeleton width={70} />
                            </span>
                          </span>
                        </div>
                        <div className="ticket-time">
                          <div className="ticket-time-inner">
                            <span className="date">
                              <Skeleton width={85} />
                            </span>
                            <span>
                              {' '}
                              <Skeleton width={90} />
                            </span>
                            <span className="city">
                              {' '}
                              <Skeleton width={70} />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="ticket-baggage">
                        <Skeleton width={30} height={30} />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="ticket-price">
                  <span className="price-passenger">
                    <span>
                      <Skeleton width={150} />
                    </span>
                    <span className="price">
                      <Skeleton width={50} />
                    </span>
                  </span>
                  <span className="total-price">
                    <span>
                      <Skeleton width={80} />
                    </span>
                  </span>
                  <Skeleton style={{ borderRadius: '50%' }} width={25} height={25} />
                  <span className="available-seats">
                    <Skeleton width={100} />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <LoaderMain systemProducts="Flights" />
      </div>
  );
};

export default FlightResultListSkeleton;

export const CheckboxSection = () => {
  return (
    <section className="flight-filter-section">
      <div className="text-bold mb-15">
        <Skeleton width={100} />
      </div>

      <Skeleton width={120} style={{ marginBottom: 10 }} />
      <Skeleton width={180} style={{ marginBottom: 10 }} />
    </section>
  );
};

export const SliderSection = () => {
  return (
    <section className="flight-filter-section">
      <div className="text-bold mb-15">
        <Skeleton width={100} />
      </div>

      <div className="flight-filter-time">
        <span>
          {' '}
          <Skeleton width={100} />
        </span>
        <span>
          {' '}
          <Skeleton width={90} />
        </span>
      </div>
      <Skeleton width={'100%'} />
    </section>
  );
};
